module.exports = require("core-js-pure/stable/instance/keys");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/keys.js
// module id = 55
// module chunks = 0 1